import {Vector as VectorSource} from 'ol/source';
import {Vector as VectorLayer} from 'ol/layer';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';


export const userPositionLayer = new VectorLayer({
    name:'Kullanıcı Konumu',
    desc:'katman',
    zIndex:10,
    source: new VectorSource({
        wrapX: false,
    })
})

export const changeUserPosition = (x,y) => {
    userPositionLayer.getSource().clear()
    let userPos = new Feature ({ geometry:new Point([x,y])
        })
    
    userPositionLayer.getSource().addFeature(userPos)

}

